export const USER_STATUS_API = "USER_STATUS_API";

export const GET_ALL_QUESTION_API = "GET_ALL_QUESTION_API";

export const GET_INTERVIEW_DETAILS_API = "GET_INTERVIEW_DETAILS_API";

export const GET_INTERVIEW_CONFIG_API = "GET_INTERVIEW_CONFIG_API";
